import { Box, Heading, Stack } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { ButtonLink } from "@src/components/ui-kit";
import { API_BASE_URL } from "@src/config/constants";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";

// const encryptionOptions = Object.values(ImapEncryptionEnum).map((value) => ({
//   label: value.toUpperCase(),
//   value,
// }));

export const ExpenseInboxIntegration = observer(
  function ExpenseInboxIntegration() {
    const {
      workspaceStore,
      settingsModalStore: {
        // expenseInboxIntegrationStore ,
        modalState,
      },
    } = useStore();
    // const form = expenseInboxIntegrationStore.form.form;

    return (
      <Stack py="4" spacing="4">
        <Heading as="h3" py="2" textAlign="left" size="md">
          {t`Expense Inbox Integration`}
        </Heading>

        <Box>
          {workspaceStore.settings?.googleEmailIntegrationEnabled ? (
            <ButtonLink
              href={`${API_BASE_URL}/google-imap/disconnect`}
              isExternal
              onClick={modalState.onClose}
              colorScheme="red"
            >
              <Trans>Disable Google integration</Trans>
            </ButtonLink>
          ) : (
            <ButtonLink
              href={`${API_BASE_URL}/google-imap/auth`}
              isExternal
              onClick={modalState.onClose}
            >
              <Trans>Enable Google integration</Trans>
            </ButtonLink>
          )}
        </Box>

        {/* <HStack alignItems="center" spacing="2">
          <Switch
            isChecked={form.$.is_active.value}
            onChange={({ target }) => {
              form.$.is_active.onChange(target.checked);
            }}
          />
          <Trans>Enabled</Trans>
        </HStack>

        {form.$.is_active.value && (
          <>
            <TextField
              label={t`IMAP Host`}
              placeholder={t`IMAP Host`}
              value={form.$.imap_host.value}
              onChange={form.$.imap_host.onChange}
              error={form.$.imap_host.error}
            />

            <TextField
              label={t`IMAP Port`}
              placeholder={t`IMAP Port`}
              value={form.$.imap_port.value}
              onChange={form.$.imap_port.onChange}
              error={form.$.imap_port.error}
            />

            <TextField
              label={t`IMAP Username`}
              placeholder={t`IMAP Username`}
              value={form.$.imap_username.value}
              onChange={form.$.imap_username.onChange}
              error={form.$.imap_username.error}
            />

            <TextField
              label={t`IMAP Password`}
              type="password"
              placeholder={t`IMAP Password`}
              value={form.$.imap_password.value}
              onChange={form.$.imap_password.onChange}
              error={form.$.imap_password.error}
            />

            <Select
              asPortal
              label={t`IMAP Encryption`}
              placeholder={t`IMAP Encryption`}
              value={form.$.imap_encryption.value}
              onChange={form.$.imap_encryption.onChange}
              error={form.$.imap_encryption.error}
              options={encryptionOptions}
            />

            <VStack justify="center" w="full" spacing="2">
              <Button
                isLoading={expenseInboxIntegrationStore.isLoadingImapTest}
                onClick={expenseInboxIntegrationStore.testImapConnection}
              >
                <Trans>Test connection</Trans>
              </Button>
            </VStack>
          </>
        )} */}
      </Stack>
    );
  },
);
